import { Link } from 'react-router-dom';
import { SEOHead } from '../../components/seo/SEOHead';
import { useAuth } from '../../hooks/useAuth';
import { useOrders } from '../../hooks/useOrders';
import { OrderCard } from '../../components/dashboard/OrderCard';
import { Spinner } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';

export default function DashboardHome() {
  const { user } = useAuth();
  const { orders, isLoading } = useOrders();

  const recentOrders = orders.slice(0, 3);
  const activeCount = orders.filter((o) => !['completed', 'cancelled', 'rejected', 'refunded'].includes(o.status)).length;

  return (
    <>
      <SEOHead title="Dashboard — Bharat Consultancy" description="" canonicalPath="/dashboard" />

      <h1 className="font-display text-2xl font-bold text-ink">Welcome back{user?.name ? `, ${user.name}` : ''}</h1>
      <p className="mt-1 text-ink/60">Here's a quick look at your account.</p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div className="rounded-lg border border-line bg-white p-5">
          <p className="text-sm text-ink/50">Total Orders</p>
          <p className="mt-1 font-display text-2xl font-bold text-ink">{orders.length}</p>
        </div>
        <div className="rounded-lg border border-line bg-white p-5">
          <p className="text-sm text-ink/50">Active Orders</p>
          <p className="mt-1 font-display text-2xl font-bold text-seal-blue">{activeCount}</p>
        </div>
        <div className="rounded-lg border border-line bg-white p-5">
          <p className="text-sm text-ink/50">Completed</p>
          <p className="mt-1 font-display text-2xl font-bold text-ledger-green">
            {orders.filter((o) => o.status === 'completed').length}
          </p>
        </div>
      </div>

      <div className="mt-8 flex items-center justify-between">
        <h2 className="font-display text-lg font-semibold text-ink">Recent Orders</h2>
        <Link to="/dashboard/orders" className="text-sm font-medium text-seal-blue">
          View All →
        </Link>
      </div>

      <div className="mt-4 space-y-3">
        {isLoading ? (
          <Spinner className="h-6 w-6 text-seal-blue" />
        ) : recentOrders.length === 0 ? (
          <div className="rounded-lg border border-dashed border-line p-8 text-center">
            <p className="text-ink/60">You haven't placed any orders yet.</p>
            <Link to="/services" className="mt-4 inline-block">
              <Button size="sm">Browse Services</Button>
            </Link>
          </div>
        ) : (
          recentOrders.map((order) => <OrderCard key={order.id} order={order} />)
        )}
      </div>
    </>
  );
}
